import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tnq-sheet-dialog',
  templateUrl: './sheet-dialog.component.html',
  styleUrls: ['./sheet-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkTrapFocus, TranslateModule],
})
export class SheetDialogComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly hasBackdrop = input<boolean>(false);
  readonly back = output<void>();
}
